<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Select from 'primevue/select';
import { usePlatformCountry } from '@/composables/usePlatformCountry';

// Login-page platform picker ("🇧🇷 Brasil ▾"): a borderless, link-style dropdown under the sign-in card.
// It only changes how the login page looks; after login the account decides the platform country.
const { t } = useI18n();
const {
    currentPlatformCountry,
    currentPlatformCountryLabel,
    currentFlagClass,
    platformCountryOptions,
    setPlatformCountry,
} = usePlatformCountry();

const selectedPlatformCountry = computed({
    get: () => currentPlatformCountry.value,
    set: (platformCountry) => void setPlatformCountry(platformCountry),
});
</script>

<template>
    <Select
        v-model="selectedPlatformCountry"
        :options="platformCountryOptions"
        option-label="label"
        option-value="value"
        :aria-label="t('common.platformCountry')"
        size="small"
        class="platform-country-select"
    >
        <template #value>
            <span class="flex items-center gap-1.5 text-xs font-medium text-surface-600">
                <span :class="currentFlagClass" class="shrink-0 rounded-sm" />
                {{ currentPlatformCountryLabel }}
            </span>
        </template>
        <template #option="{ option }">
            <span class="flex items-center gap-2 text-sm">
                <span :class="option.flagClass" class="shrink-0 rounded-sm" />
                {{ option.label }}
            </span>
        </template>
    </Select>
</template>

<style scoped>
.platform-country-select.p-select {
    background: transparent;
    border-color: transparent;
    box-shadow: none;
}

.platform-country-select.p-select:hover,
.platform-country-select.p-select.p-focus {
    background: var(--p-surface-100);
}
</style>
